import { Anchor, PageHeading } from 'components/atoms';
import { Head, PageLayout } from 'components/molecules';
import { getTranslations } from 'i18n';
import type { GetServerSideProps, NextPage } from 'next';
import React, { Fragment } from 'react';
import { useTranslation } from 'utils/hooks';
import { TranslationKey } from 'utils/hooks/useTranslation';

const ImpressumPage: NextPage = () => 
{
  const { t, r } = useTranslation('imprint');

  function renderSection(key: TranslationKey, doubleBreak: boolean = false)
  {
    return Object.values(t(key, { returnObjects: true })).map((_, index) => (
      <Fragment key={`${key}.${index}`}>
        {r(`${key}.${index}` as unknown as TranslationKey, {
          ris: <Anchor href="https://www.ris.bka.gv.at/" target="_blank" external />,
        })}
        <br/>
        {doubleBreak && <br />}
      </Fragment>
    ));
  }

  return (
    <PageLayout textContentPage>

      <Head title={t('imprint:meta.title')}>
        <meta name="description" content={t('imprint:meta.description')} />
        <meta name="keywords" content="" />
      </Head>

      <PageHeading title={t('imprint:heading')} />

      <p>{renderSection('imprint:address')}</p>
      <p>{renderSection('imprint:contact')}</p>
      <p>{renderSection('imprint:fb')}</p>
      <p>{renderSection('imprint:banking')}</p>
      <p>{renderSection('imprint:other', true)}</p>

    </PageLayout>
  );
};

export default ImpressumPage;

export const getServerSideProps: GetServerSideProps = async (ctx) =>
{
  const { locale } = ctx;
  const translations = await getTranslations(locale, 'imprint');

  return { props: { ...translations } };
};
